/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useEffect, useState } from 'react'
import ReactSelect, { OptionTypeBase, Props as SelectProps } from 'react-select'
import { useField } from '@unform/core'
import { Container, Label, BoxInput } from './styles'

interface Props extends SelectProps<OptionTypeBase> {
  name: string
  label?: string
}

export const FormlessSelect: React.FC<Props> = ({
  name,
  label,
  itemValue,
  defaultValue,
  ...rest
}: any) => {
  const selectRef = useRef(null)

  return (
    <Container className='container-input-react-select'>
      <BoxInput className='box-input-react-select' style={{ borderColor: '#707070' }}>
        <ReactSelect
          defaultValue={defaultValue}
          menuPosition="fixed"
          ref={selectRef}
          placeholder="Selecione a quantidade de parcelas"
          className="react-select-container"
          theme={(theme) => ({
            ...theme,
            borderRadius: 8,
            colors: {
              ...theme.colors,
              primary25: '#ecffbb',
              primary: 'var(--primaryColor)',
            },
          })}
          classNamePrefix="react-select"
          {...rest}
        />
      </BoxInput>
    </Container>
  )
}
